/* eslint-disable react/prop-types */
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";
import moment from "moment";
import { BsCalendarDate } from "react-icons/bs";
import { IoCopyOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import { toast } from "sonner";
// import { toast } from "react-hot-toast";

const OrderDetails = ({ token, open, setOpen }) => {
  const copyToken = (d) => {
    navigator.clipboard
      .writeText(d)
      .then(() => {
        toast.success("Token copied to clipboard");
      })
      .catch(() => {
        toast.error("Failed to copy token");
      });
  };

  const copySerialNo = (serialNo) => {
    navigator.clipboard
      .writeText(serialNo)
      .then(() => {
        toast.success("Serial number copied to clipboard");
      })
      .catch(() => {
        toast.error("Failed to copy serial number");
      });
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        {/* <Button variant="outline">Show Dialog</Button> */}
      </AlertDialogTrigger>
      <AlertDialogContent className="dark:bg-darkBg w-full bg-white px-3 md:max-w-[45rem] md:px-6 lg:max-w-4xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Order Details</AlertDialogTitle>
          <AlertDialogDescription>
            Details of purchased exam tokens, including serial numbers and
            identifiers.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="flex max-h-[70vh] flex-col gap-4 overflow-y-auto pr-2">
          <div className="dark:border-darkBorder w-full rounded-xl border p-4 md:w-fit">
            <div className="mb-1 flex items-center gap-1">
              <TbRefresh className="text-lg text-gray-600 dark:text-gray-300" />
              <p className="text-gray-600 dark:text-gray-300">
                <span className="font-semibold">Transaction ID:</span>{" "}
                {token.id}
              </p>
            </div>

            <div className="mb-1 flex items-center gap-1">
              <BsCalendarDate className="text-lg text-gray-600 dark:text-gray-300" />
              <p className="text-gray-600 dark:text-gray-300">
                <span className="font-semibold">Date:</span>{" "}
                {moment(token.date).format("Do, ddd MMM YYYY [at] h:mma")}
              </p>
            </div>

            {/* <div className="mb-1 flex items-center gap-1  text-gray-600 dark:text-gray-300">
              <GrMoney className="text-xl" />
              <p className="">
                <span className="font-semibold">Total Paid:</span> ₦
                {formatter.format(details.total)}
              </p>
            </div> */}
          </div>

          <div
            className={cn(
              "grid w-full grid-cols-1 gap-3 md:grid-cols-2 md:gap-4 lg:grid-cols-3",
              {
                "md:grid-cols-1": token.token?.split(",").length === 1,
              },
            )}
          >
            {token?.token?.split(",")?.map((order, index) => (
              <div
                key={index}
                className="dark:border-darkBorder dark:bg-darkInput flex flex-col rounded-xl border"
              >
                <div className="rounded-t-xl bg-gray-100 py-3 pl-3 dark:bg-gray-300">
                  <h1 className="font-manrope text-base font-semibold text-black/75">
                    {token.type}
                  </h1>
                </div>

                <div className="flex flex-col gap-3 p-3 py-7 text-sm font-semibold text-black/75 dark:text-white">
                  <div className="flex items-center justify-between">
                    <p>Token: {order}</p>

                    <IoCopyOutline
                      cursor="pointer"
                      onClick={() => copyToken(order)}
                    />
                  </div>

                  <div className="flex items-center justify-between">
                    <p>Serial Number: {token.serial?.split(",")[index]}</p>
                    <IoCopyOutline
                      cursor="pointer"
                      onClick={() =>
                        copySerialNo(token.serial?.split(",")[index])
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel className="dark:bg-slate-700 dark:text-white">
            Close
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default OrderDetails;
